import "./css/style.scss";
import City from "./Components/City.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import Reveal from "./Components/Reveal.jsx";

export default function Home({ content, goDown }) {
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section id="home">
      <div className="home">
        <div className="container">
          <div className="left-side">
            <div className="title">
              <div>
                <Reveal delay={0.4}>
                  <h1>{content.title}</h1>
                </Reveal>
                <Reveal delay={0.6}>
                  <h2>{content.subtitle}</h2>
                </Reveal>
                <Reveal delay={0.8}>
                  <h3>{content.paragraph}</h3>{" "}
                </Reveal>
              </div>
            </div>
          </div>
          <div className="right-side">
            <City blocks={content.blocks} />
          </div>
          <div
            className={scrollPosition > 0 ? "chevron ch-off" : "chevron ch-on"}
            onClick={() => {
              if (scrollPosition == 0) {
                goDown();
              }
            }}
          >
            <FontAwesomeIcon className="icon" icon={faChevronDown} bounce />
          </div>
        </div>
      </div>
    </section>
  );
}
